import { IHealthCheckResult } from './runHealthCheck';
import { countsAsWarning } from './types';

/**
 * Das Health-Check-Ergebnis, wie es beim Speichern ans Backend mitreist
 * (#1283/#1330).
 *
 * Grosse Anfangsbuchstaben, weil das die Schreibweise der übrigen Felder des
 * Vorgangs-Objekts ist.
 */
export interface IHealthCheckSavePayload {
  WarningCount: number;
  Findings: {
    RuleKey: string;
    Severity: string;
    Section: string;
    Message: string;
  }[];
}

/**
 * Bereitet das Ergebnis für den Protokolleintrag auf — oder `undefined`, wenn
 * es nichts zu protokollieren gibt.
 *
 * Das Feld reist nur mit und wird nicht am Vorgang gespeichert; es darf
 * deshalb nicht in den Änderungsvergleich geraten, sonst hielte DiNo den
 * Vorgang für geändert, obwohl nur geprüft wurde.
 *
 * Ohne Warnung entsteht kein Eintrag: dass gespeichert wurde, steht ohnehin im
 * Protokoll. Reine Hinweise fallen auch aus der Liste — der Eintrag soll
 * erklären, worüber sich jemand bewusst hinweggesetzt hat, und ein Hinweis
 * gehört nicht dazu.
 */
export const healthCheckSavePayload = (
  result: IHealthCheckResult
): IHealthCheckSavePayload | undefined => {
  if (result.warningCount < 1) {
    return undefined;
  }

  return {
    WarningCount: result.warningCount,
    Findings: result.findings.filter(countsAsWarning).map(finding => ({
      RuleKey: finding.ruleKey,
      Severity: finding.severity,
      Section: finding.section,
      Message: finding.message,
    })),
  };
};
